import { Switch } from 'antd';

import { Schemas } from '@api-client/generated/types';
import { ACCESS_RIGHTS } from '@constants';

import * as S from './styled';

type AccessRights = Schemas.AccessRights;

type Props = {
  value: AccessRights;
  onChange: (value: AccessRights) => void;
  disabled?: boolean;
};

/** Editable grid of the six access rights, each a labelled switch. */
const AccessRightsGrid = ({ value, onChange, disabled }: Props) => (
  <S.RightsGrid>
    {ACCESS_RIGHTS.map(({ key, label }) => (
      <S.RightRow key={key} align="center" justify="space-between" gap={12}>
        <S.RightLabel>{label}</S.RightLabel>
        <Switch
          checked={value[key]}
          disabled={disabled}
          onChange={(checked) => onChange({ ...value, [key]: checked })}
        />
      </S.RightRow>
    ))}
  </S.RightsGrid>
);

export default AccessRightsGrid;
